import { QueryClient } from "@tanstack/react-query";

// Module-level so non-React code (AuthContext's signOut) can clear the cache
// without a useQueryClient() hook — AuthProvider sits *outside*
// QueryClientProvider (see index.tsx), so the hook isn't available there.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
